<template>
    <div class="card-informativo">
        <div class="card-image" :style="backgroundImageStyle">
            <div class="card-badge">
                <i class="far fa-calendar-alt me-1"></i>
                {{ formatDate(informativo.dataFinal) }}
            </div>
        </div>
        <div class="card-content">
            <h4 class="card-title" :title="informativo.titulo">{{ informativo.titulo }}</h4>
            <p class="card-description" :title="informativo.descricao">{{ informativo.descricao }}</p>
            
            <div class="card-actions">
                <router-link 
                    :to="{
                        name: 'Informativo Login Hotel',
                        params: { id: informativo.id }
                    }" 
                    class="btn-edit">
                    <i class="fas fa-edit"></i>
                    <span>Editar</span>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "CardInformativos",
    props: {
        informativo: {
            type: Object,
            required: true,
            default: () => ({
                titulo: '',
                descricao: '',
                dataFinal: null,
                urlImg: ''
            })
        },
    },
    computed: {
        imageUrl() {
            console.log('URL da imagem:', this.informativo.urlImg);
            return this.informativo.urlImg ? encodeURI(this.informativo.urlImg) : '/placeholder-image.jpg';
        },
        backgroundImageStyle() {
            console.log('Style aplicado:', `url("${this.imageUrl}")`); 
            return {
                backgroundImage: `url("${this.imageUrl}")`
            };
        }
    },
    methods: {
        formatDate(date) {
            if (!date) return '';
            const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
            return new Date(date).toLocaleDateString('pt-BR', options);
        }
    }
}

</script>

<style lang="scss" scoped>
.card-informativo {
    position: relative;
    width: 100%;
    background: white;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);

        .card-image::after {
            opacity: 0.7;
        }

        .btn-edit {
            background: #007bff;
            color: white;
            
            i {
                transform: rotate(15deg);
            }
        }
    }
}

.card-image {
    position: relative;
    width: 100%;
    height: 200px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

    &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(45deg, rgba(0,0,0,0.4), transparent);
        opacity: 0.5;
        transition: opacity 0.3s ease;
    }
}

.card-badge {
    position: absolute;
    top: 15px;
    right: 15px;
    background: rgba(255, 255, 255, 0.95);
    padding: 6px 12px;
    border-radius: 20px;
    font-size: 0.85rem;
    color: #444;
    backdrop-filter: blur(4px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    z-index: 1;
    transition: all 0.3s ease;

    i {
        color: #007bff;
    }
}

.card-content {
    padding: 20px;
}

.card-title {
    font-size: 1.25rem;
    font-weight: 600;
    color: #2c3e50;
    margin: 0 0 10px 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.card-description {
    font-size: 0.95rem;
    color: #666;
    margin-bottom: 20px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.5;
}

.card-actions {
    display: flex;
    justify-content: flex-end;
}

.btn-edit {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 8px 16px;
    background: #f8f9fa;
    color: #007bff;
    border-radius: 6px;
    text-decoration: none;
    font-weight: 500;
    font-size: 0.9rem;
    transition: all 0.3s ease;

    i {
        transition: transform 0.3s ease;
    }

    &:hover {
        text-decoration: none;
    }
}


</style>